import { json } from "utils/http/client";

export const ContractorApi = {
  deleteById: (contractorId) =>
    json(`/org/contractors/delete/${Number(contractorId)}`, {
      method: "DELETE",
    }),
  fetchContractors: (data) =>
    json(`/org/contractors/`, {
      method: "POST",
      body: data,
    }),
  getWorkOrdersByContractor: (contractorId) =>
    json(`/org/work-orders/by-contractor/${contractorId}/`, {
      method: "GET",
    }),
  getPaymentsByContractor: (contractorId) =>
    json(`/org/contractor/payments/${contractorId}/`, {
      method: "GET",
    }),
  getWorkOrderDetail: (workOrderId) =>
    json(`/org/work-order/${workOrderId}/details/`, {
      method: "GET",
    }),
  upgradeWorkOrder: (workOrderId, data) =>
    json(`/org/work-order/${workOrderId}/upgrade/`, {
      method: "POST",
      body: data,
    }),
  createPayment: (data) =>
    json(`/org/work-order/create-payment/`, {
      method: "POST",
      body: data,
    }),
  createAttendance: (data) =>
    json(`/org/contractor/attendance/create/`, {
      method: "POST",
      body: data,
    }),
  getAttendanceByContractor: (contractorId) =>
    json(`/org/contractor/attendance/${contractorId}/`, {
      method: "GET",
    }),
  updateAttendance: (attendanceId, data) =>
    json(`/org/contractor/attendance/update/${attendanceId}/`, {
      method: "PATCH",
      body: data,
    }),
  /**
   * PATCH /org/contractors/{contractor_id}/update/
   */
  updateContractor: (contractorId, payload) =>
    json(`/org/contractors/${Number(contractorId)}/update/`, {
      method: "PATCH",
      body: payload,
    }),
  updateScopeItem: (scopeId, payload) =>
    json(`/org/work-order/update/scope/${scopeId}/`, {
      method: "PATCH",
      body: payload,
    }),
  updateMilestone: (milestoneId, payload) =>
    json(`/org/work-order/update/milestone/${milestoneId}/`, {
      method: "PATCH",
      body: payload,
    }),
};


